export const PAGEABLE_DATASOURCE_DEFAULT_PAGE_SIZE = 25;
